import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "../Home/ScrollIndicator";

import TrombinoCard from "./components/TrombinoCard";
import TrombinoEmptyState from "./components/TrombinoEmptyState";
import TrombinoFilters from "./components/TrombinoFilters";
import TrombinoLightbox from "./components/TrombinoLightbox";
import TrombinoSkeleton from "./components/TrombinoSkeleton";

import { TROMBINOS_PAGE } from "./data/trombinosUiData";
import { useTrombinosPage } from "./hooks/useTrombinosPage";

export default function TrombinosPage() {
  useScrollToTop();

  const {
    loading,
    error,
    items,
    allTotal,
    total,
    services,
    stats,
    filters,
    photoPreview,
    updateFilter,
    resetFilters,
    openPhoto,
    closePhoto,
    refresh,
  } = useTrombinosPage();

  return (
    <>
      <PageHero
        title={TROMBINOS_PAGE.title}
        subtitle={TROMBINOS_PAGE.description}
        imageUrl={TROMBINOS_PAGE.heroImageUrl}
        crumbs={TROMBINOS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={TROMBINOS_PAGE.eyebrow}
          title={TROMBINOS_PAGE.title}
          description={TROMBINOS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Profils publics
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : allTotal}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              personne{allTotal > 1 ? "s" : ""} référencée
              {allTotal > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <TrombinoFilters
            loading={loading}
            filters={filters}
            services={services}
            stats={stats}
            total={total}
            allTotal={allTotal}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={refresh}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement du trombinoscope.
          </div>
        )}

        <section className="mt-6">
          {loading ? (
            <TrombinoSkeleton />
          ) : items.length > 0 ? (
            <div className="grid gap-5 xl:grid-cols-2">
              {items.map((person, index) => (
                <TrombinoCard
                  key={person.id}
                  person={person}
                  delay={Math.min(index * 35, 180)}
                  onOpenPhoto={openPhoto}
                />
              ))}
            </div>
          ) : (
            <TrombinoEmptyState onReset={resetFilters} />
          )}
        </section>
      </main>

      <TrombinoLightbox preview={photoPreview} onClose={closePhoto} />
    </>
  );
}